import * as React from "react"

//This is a Basic 404 component
export const NoMatch: React.FunctionComponent = (props) => {

    return(
        <div>
            <h2>Erreur 404</h2>
            <div>Cette page n'existe pas !</div>
        </div>
    )
}